var _svg;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DesempenoLight = function DesempenoLight(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _svg || (_svg = /*#__PURE__*/_jsx("svg", {
      width: "24",
      height: "24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsxs("g", {
        fill: "currentColor",
        children: [/*#__PURE__*/_jsx("path", {
          opacity: ".4",
          d: "M12.925 19.286h7.088V8.61c0-1.925-1.575-3.588-3.588-3.588-1.925 0-3.587 1.575-3.587 3.588v10.675h.087Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M16.429 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
        }), /*#__PURE__*/_jsx("path", {
          opacity: ".4",
          d: "M7.588 19.286c1.924 0 3.587-1.575 3.587-3.587v-3.5c0-1.925-1.575-3.588-3.588-3.588C5.663 8.611 4 10.186 4 12.2v3.587c.088 1.925 1.662 3.5 3.588 3.5Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M7.587 19.287a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
        })]
      })
    }))
  });
};
export default DesempenoLight;